/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminRiskSummaryDto } from './AdminRiskSummaryDto';
import {
    AdminRiskSummaryDtoFromJSON,
    AdminRiskSummaryDtoFromJSONTyped,
    AdminRiskSummaryDtoToJSON,
    AdminRiskSummaryDtoToJSONTyped,
} from './AdminRiskSummaryDto';

/**
 * 
 * @export
 * @interface GetAdminRiskListResponseDto
 */
export interface GetAdminRiskListResponseDto {
    /**
     * 
     * @type {number}
     * @memberof GetAdminRiskListResponseDto
     */
    totalCount: number;
    /**
     * 
     * @type {Array<AdminRiskSummaryDto>}
     * @memberof GetAdminRiskListResponseDto
     */
    items: Array<AdminRiskSummaryDto>;
}

/**
 * Check if a given object implements the GetAdminRiskListResponseDto interface.
 */
export function instanceOfGetAdminRiskListResponseDto(value: object): value is GetAdminRiskListResponseDto {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetAdminRiskListResponseDtoFromJSON(json: any): GetAdminRiskListResponseDto {
    return GetAdminRiskListResponseDtoFromJSONTyped(json, false);
}

export function GetAdminRiskListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAdminRiskListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(AdminRiskSummaryDtoFromJSON)),
    };
}

export function GetAdminRiskListResponseDtoToJSON(json: any): GetAdminRiskListResponseDto {
    return GetAdminRiskListResponseDtoToJSONTyped(json, false);
}

export function GetAdminRiskListResponseDtoToJSONTyped(value?: GetAdminRiskListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(AdminRiskSummaryDtoToJSON)),
    };
}

